"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _GracePeriodErrorStyled = require("./GracePeriodErrorStyled");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AlertIcon = function AlertIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.077 12.372a11.057 11.057 0 0 1-10.938 11.172A11.057 11.057 0 0 1 1.2 12.372 11.057 11.057 0 0 1 12.139 1.2a11.057 11.057 0 0 1 10.938 11.172Z",
    fill: "none",
    stroke: "#e66370",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.139 13.572a1.2 1.2 0 0 1-1.2-1.2V7.663a1.2 1.2 0 0 1 2.4 0v4.709a1.2 1.2 0 0 1-1.2 1.2Z",
    fill: "#e66370"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.139 16.841h0",
    fill: "none",
    stroke: "#e66370",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.4"
  })));
};
AlertIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24.277",
  height: "24.744"
};
var GracePeriodError = function GracePeriodError() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var currentPlan = (0, _reactRedux.useSelector)(function (state) {
    return state.plan.currentPlan;
  });
  var displayGracePeriodError = (0, _reactRedux.useSelector)(function (state) {
    return state.publisherConfig.displayGracePeriodError;
  });
  (0, _react.useEffect)(function () {
    if (displayGracePeriodError && !currentPlan) {
      dispatch((0, _planDetailsSlice.fetchCustomerOffers)());
    }
  }, [displayGracePeriodError]);
  var isPeriodError = displayGracePeriodError && (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.some(function (_ref) {
    var status = _ref.status,
      expiresAt = _ref.expiresAt;
    return status === 'active' && new Date(expiresAt * 1000) < new Date();
  }));
  if (!isPeriodError) return null;
  return /*#__PURE__*/_react.default.createElement(_GracePeriodErrorStyled.GracePeriodErrorStyled, {
    "data-testid": "grace-period-error"
  }, /*#__PURE__*/_react.default.createElement(_GracePeriodErrorStyled.IconStyled, null, /*#__PURE__*/_react.default.createElement(AlertIcon, {
    "data-testid": "alert-svg"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "grace-period-error"
  }, "Your subscription couldn't be renewed due to a payment method issue. Please ", /*#__PURE__*/_react.default.createElement(_GracePeriodErrorStyled.WarningMessageStyled, null, "update it"), ' ', "to avoid losing access to the content.")));
};
var _default = GracePeriodError;
exports.default = _default;